'use client';

import { useCallback, useContext } from 'react';
import { GeneralContext } from '@frodo/lib/providers/GeneralProvider';
import { PAGE_TYPE_VCT_MAP } from '@frodo/lib/utils/common/constants';

export const useVct = () => {
  const context = useContext(GeneralContext);
  const pageType = context?.pageType;

  const buildVct = useCallback(
    (vct: string) => {
      const prefix = pageType ? PAGE_TYPE_VCT_MAP[pageType] : undefined;

      return prefix ? `${prefix}_${vct}` : vct;
    },
    [pageType],
  );

  return { buildVct };
};
